import env from './env';

const settings = {
    loggingEnabled: env.isProduction,
    isSuspenseSupported: env.isSuspenseSupported,
};

export default Object.freeze({
    logging: {
        enable: () => {
            settings.loggingEnabled = true;
        },
        disable: () => {
            settings.loggingEnabled = false;
        },
        isEnabled: () => settings.loggingEnabled,
    },
    isSuspenseSupported: settings.isSuspenseSupported,
});
